import urls from 'constants/urls';
import history from 'utils/history';
import locator from 'utils/locator';
import { isInternal } from 'utils/is-internal';
import { matchPath } from 'react-router-dom';

const pathsRequiringPageReload = [
  urls.login,
  urls.checkout,
  urls.paymentCards,
  urls.resolveOrderPayment,
  urls.marketingPreferences,
  urls.myAccount,
  urls.myDetailsPage,
  urls.myWaitrosePage,
  urls.joinMyWaitrose,
  urls.myWaitroseVouchers,
  urls.myWaitroseBecomeAMember,
  urls.myWaitroseMigrationCompetitions,
  urls.myWaitroseMigrationBenefits,
  urls.myWaitroseMigrationCardAndDetails,
  urls.rewards,
  urls.rewardsJohnLewis,
  urls.myWaitroseRewards,
  urls.trolleyPage,
];

const urlsRequiringReloadOnNavigateAway = [urls.checkout, urls.resolveOrderPayment];

export const pathRequiresReload = (pathname: string) => {
  return pathsRequiringPageReload.some(path => matchPath(path, pathname));
};

export const pathReloadOnNavigateAway = (pathname: string) => {
  return urlsRequiringReloadOnNavigateAway.some(path => matchPath(path, pathname));
};

export const goToInternalOrExternalLocation = (url: string) => {
  if (__SERVER__) {
    locator.href = url;
    return;
  }
  if (isInternal(url) && !pathRequiresReload(url) && !pathReloadOnNavigateAway(locator.pathname)) {
    history.push(url);
  } else {
    locator.href = url;
  }
};
